import React, { useEffect, useState } from "react";
import { LoadingDiv, SweetAlertShow } from "../master/Master";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { batchList, batchStudentsMarksheetData } from "../../api/Batch";
import { printImg } from "../master/Print";
import StudentMarksheet1 from "../components/StudentMarksheet1";
import StudentMarksheet2 from "../components/StudentMarksheet2";
import StudentMarksheet3 from "../components/StudentMarksheet3";
import StudentMarksheet4 from "../components/StudentMarksheet4";
import StudentMarksheet5 from "../components/StudentMarksheet5";
import { imgBaseUrl } from "../../api/api";
import StudentMarksheet6 from "../components/StudentMarksheet6";
import TestLayout from "../main/testsList/TestLayout";
import StudentOldMarksheet2 from "../components/StudentOldMarksheet2";
import StudentOldMarksheet3 from "../components/StudentOldMarksheet3";
import StudentOldMarksheet4 from "../components/StudentOldMarksheet4";
import StudentOldMarksheet5 from "../components/StudentOldMarksheet5";
import StudentOldMarksheet6 from "../components/StudentOldMarksheet6";
import usePrivateLink from "../config/usePrivateLink";
import StudentMarksheet7 from "../components/StudentMarksheet7";

export default function StudentMarksheet() {
  const [setting, setSetting] = useState({});
  const hasAccess = usePrivateLink();

  useEffect(() => {
    setSetting(JSON.parse(localStorage.getItem("setting") ?? {}));
  }, []);
  const [loading, setLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [batchData, setBatchData] = useState({});
  const [students, setStudents] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [filters, setFilters] = useState();
  const [template, setTemplate] = useState("1");
  const [examDate, setExamDate] = useState(
    new Date().toISOString().split("T")[0],
  );

  useEffect(() => {
    const parseSessions = JSON.parse(localStorage.getItem("sessions") ?? "[]");
    setSessions(parseSessions);
    setFilters({
      ...filters,
      session_id: parseSessions?.find((s) => s.status === "1")?.id,
    });
  }, []);

  const getBatchList = async () => {
    setLoading(true);
    try {
      let addUrl = "";
      if (filters?.session_id) {
        addUrl = `&session_id=${filters?.session_id}`;
      }
      const response = await batchList(addUrl);
      if (response.data.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchInfo = async (id) => {
    setLoading(true);
    try {
      let addUrl = `&batch_id=${id}`;
      const response = await batchStudentsMarksheetData(addUrl);
      if (response.data.status) {
        setBatchData(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBatchList();
  }, [filters]);

  const templates = [
    { id: "1", name: "Classic Blue", component: StudentMarksheet1 },
    { id: "2", name: "Modern Minimal", component: StudentMarksheet2 },
    { id: "3", name: "Formal Serif", component: StudentMarksheet3 },
    { id: "4", name: "Sidebar Profile", component: StudentMarksheet4 },
    { id: "5", name: "Score Dashboard", component: StudentMarksheet5 },
    { id: "6", name: "Editorial Ruled", component: StudentMarksheet6 },
    { id: "7", name: "Marksheet 2", component: StudentOldMarksheet2 },
    { id: "8", name: "Marksheet 3", component: StudentOldMarksheet3 },
    { id: "9", name: "Marksheet 4", component: StudentOldMarksheet4 },
    { id: "10", name: "Marksheet 5", component: StudentOldMarksheet5 },
    { id: "11", name: "Marksheet 6", component: StudentOldMarksheet6 },
    { id: "12", name: "Multi-Test Report", component: StudentMarksheet7 },
  ];

  const handleBarCodePrint = async (id) => {
    setLoading(true);
    const invoiceElement = document.getElementById(id);
    if (!invoiceElement) return;
    const content = invoiceElement.outerHTML;
    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      alert("Popup blocked!");
      return;
    }

    printWindow.document.write(`
      <html>
        <head>
       <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
       <link href="https://cdn.jsdelivr.net/npm/remixicon@4.9.1/fonts/remixicon.css" rel="stylesheet">
<link href="https://cdnjs.cloudflare.com/ajax/libs/remixicon/4.6.0/remixicon.min.css" rel="stylesheet">
          <title>Print Marksheet</title>
          <style>
           @page { size: 210mm 297mm; margin: 2mm; }
            body { margin: 0; }
         .a4-page-marksheet * {
    color: black !important;
    text-transform: uppercase !important;
    border: none !important;
}

.a4-page-marksheet {
    width: 210mm !important;
    height: 290mm !important;
    border: 1pt solid black !important;
    position: relative;
    z-index: 1;
    color: black !important;
}

.a4-page-marksheet::before {
    content: "";
    position: absolute;
    inset: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 300px;
    opacity: 0.2;
    z-index: 1;
}

.a4-page-marksheet .border {
    border: 1pt solid black !important;
}

.a4-page-marksheet *{
    font-size: 11px;
    color: black;
}
.a4-page-marksheet .ri-28px{
    font-size:24px !important;
}

.a4-page-marksheet .bg-marksheet-header {
    background-color: #1354ea6b !important;
    border-radius: 10px;
    padding: 15px 5px;
    border: 1pt solid #1353eaa2 !important;
    font-size: 20px !important;
    font-weight:500 !important;
}

.a4-page-marksheet .bg-primary {
    background-color: #1354ea6b !important;
    color: black !important;
}
.a4-page-marksheet .text-primary {
    color: #1354ea6b !important;

}

.a4-page-marksheet .student-details .col-2{
    width: 17% !important;
    margin: 0;
 }

.a4-page-marksheet .student-details .col-1{
   width: 1% !important;
   padding: 0;
   margin: 0;
}
.a4-page-marksheet .student-details .col-3{
   width: 32% !important;
}

.a4-page-marksheet .table  th{
    border: 1pt solid black !important;
    align-self: center !important;
    text-align: center !important;
    padding: 5px;
}
.a4-page-marksheet .table  td{
    border: 1pt solid black !important;
    align-self: center !important;
    text-align: center !important;
    padding: 5px;
}

.a4-page-marksheet .table .bg-primary  th{
    background-color: #1354ea42 !important;
}
.a4-page-marksheet .table .bg-primary  td{
    background-color: #1354ea42 !important;
}


.a4-page-marksheet .diagonal-cell {
    position: relative;
    padding: 0;
  }

  .a4-page-marksheet .diagonal-cell::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1pt;
    background: black;
    top: 50%;
    left: 0;
    transform: rotate(-9deg);
    transform-origin: center;
  }
  
  .a4-page-marksheet .top-value {
    position: absolute;
    top: 2px;
    left: 10px;
  }
  
  .a4-page-marksheet .bottom-value {
    position: absolute;
    bottom: 2px;
    right: 10px;
  }
  .a4-page-marksheet .checkbox {
    margin-left: 3px;
   border: 1pt solid black;
   align-self: center !important;
   border-radius: 5px;
   padding: 0 8px;
  }


          </style>
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 300);
    };
    setLoading(false);
  };

  return (
    <>
      <style>
        {`
            .a4-page-marksheet::before{
                background-image: url(${imgBaseUrl + setting?.logo_img});
            }
        `}
      </style>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <TestLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-3 align-items-center">
                          <div className="col-12">
                            <h4 className="text-primary m-0">
                              Student Marksheet
                            </h4>
                            <hr />
                          </div>

                          <div className="col-sm-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={filters?.session_id}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    session_id: e.target.value,
                                  })
                                }
                              >
                                <option value="">All</option>
                                {sessions.map((session, index) => (
                                  <option key={index} value={session.id}>
                                    {session.session} :{" "}
                                    {session?.status === "1"
                                      ? "Active"
                                      : "Inactive"}
                                  </option>
                                ))}
                              </select>
                              <label className="">Session</label>
                            </div>
                          </div>
                          <div className="col-sm-3">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                name="batch_id"
                                onChange={(e) => {
                                  setBatchData([]);
                                  getBatchInfo(e.target.value);
                                }}
                              >
                                <option value="" selected disabled>
                                  Select Batch
                                </option>
                                {batches?.map((batch, i) => (
                                  <option key={i} value={batch?.id}>
                                    {batch?.title} ({batch?.course?.title})
                                  </option>
                                ))}
                              </select>
                              <label htmlFor="batch_id">Select Batch</label>
                            </div>
                          </div>
                          {batchData?.active_batch_students && (
                            <>
                              <div className="col-sm-3">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    name="student_id"
                                    onChange={(e) => {
                                      const value = e.target.value;

                                      if (value === "all") {
                                        setStudents(
                                          batchData?.active_batch_students ||
                                            [],
                                        );
                                      } else {
                                        setStudents(
                                          batchData?.active_batch_students?.filter(
                                            (student) =>
                                              student?.student_id ===
                                              Number(value),
                                          ) || [],
                                        );
                                      }
                                    }}
                                  >
                                    <option value="" selected disabled>
                                      Select Student
                                    </option>
                                    <option value="all">All</option>
                                    {batchData?.active_batch_students?.map(
                                      (student, i) => (
                                        <option
                                          key={i}
                                          value={student?.student_id}
                                        >
                                          {student?.student_info?.name} (
                                          {
                                            student?.student_info
                                              ?.registration_no
                                          }
                                          )
                                        </option>
                                      ),
                                    )}
                                  </select>
                                  <label htmlFor="student_id">
                                    Select Student
                                  </label>
                                </div>
                              </div>

                              <div className="col-sm-2">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={template}
                                    onChange={(e) =>
                                      setTemplate(e.target.value)
                                    }
                                  >
                                    <option value="" disabled>
                                      Select Template
                                    </option>

                                    {templates.map((t) => (
                                      <option key={t.id} value={t.id}>
                                        {t.name}
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="template_name">
                                    Select Template
                                  </label>
                                </div>
                              </div>

                              <div className="col-sm-2 ">
                                <div className="form-floating form-floating-outline">
                                  <input
                                    type="date"
                                    className="form-control"
                                    value={examDate}
                                    onChange={(e) =>
                                      setExamDate(e.target.value)
                                    }
                                  />
                                  <label htmlFor=""> Marksheet Date</label>
                                </div>
                              </div>

                              <div className="col-sm-4">
                                {hasAccess("/marksheet/print") && (
                                  <>
                                    <button
                                      className="btn btn-primary me-2"
                                      onClick={() => printImg("PrintDiv")}
                                    >
                                      Print
                                    </button>
                                    <button
                                      className="btn btn-primary"
                                      onClick={() =>
                                        handleBarCodePrint("PrintDiv")
                                      }
                                    >
                                      Print V2
                                    </button>
                                  </>
                                )}
                              </div>
                            </>
                          )}

                          <div className="col-12">
                            <hr />
                          </div>

                          <div
                            className="col-12 a4-page d-flex flex-wrap justify-content-center align-content-center gap-6"
                            id="PrintDiv"
                          >
                            {students?.map((student, i) => {
                              const selected = templates.find(
                                (t) => t.id === template,
                              );
                              const Component = selected?.component;
                              if (!Component) return null;
                              return (
                                <Component
                                  key={i}
                                  data={student}
                                  batch={batchData}
                                  examDate={examDate}
                                />
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
